/**
 * 从 session storage 读取 json 数据
 * @param {String} key
 */
export function getSessionItem(key) {
  var jsonStr = sessionStorage.getItem(key);
  if (jsonStr) {
    try {
      var json = JSON.parse(jsonStr);
      return json;
    } catch (e) {
      console.warn('failed to parse json from session storage item, got exception:', e);
    }
  }
  return null;
}
/**
 * 从 session storage 移出数据
 * @param {String} key
 */
export function removeSessionItem(key) {
  sessionStorage.removeItem(key);
}
export function setSessionItem(key, value) {
  var jsonStr = JSON.stringify(value);
  sessionStorage.setItem(key, jsonStr);
}
export default {
  getSessionItem: getSessionItem,
  removeSessionItem: removeSessionItem,
  setSessionItem: setSessionItem
};